import clsx from 'classnames';
import React from 'react';

import { useBrowserScreen } from '~/components/ExtendedGlobalHeader/hooks/useBrowserScreen';

type LinkItem = { title: string; url: string; ariaLabel: string };

type LinkListProps = {
  heading: string;
  iconStc?: string;
  columnsNumber?: '1' | '2' | '3';
  isDivider?: boolean | string | number;
  links: LinkItem[];
  className?: string;
};

type LListStyle = React.CSSProperties & {
  ['--llist-cols']?: number | string;
};

const LinkList: React.FC<LinkListProps> = ({
  heading = 'Type of Event',
  iconStc,
  columnsNumber = '3',
  isDivider,
  links,
  className = '',
}) => {
  const headingId = React.useId();
  const { isDesktopView } = useBrowserScreen();

  const cols = !isDesktopView ? 1 : parseInt(columnsNumber, 10) || 1;
  const style: LListStyle = { '--llist-cols': cols };

  return (
    <section
      className={clsx(
        'llist',
        { 'llist--divider': isDivider && isDesktopView },
        className
      )}
      style={style}
      aria-labelledby={headingId}
    >
      <div className="llist__header">
        {iconStc && isDesktopView && (
          <img
            className="llist__icon"
            src={iconStc}
            alt=""
            aria-hidden="true"
          />
        )}
        <h3 id={headingId} className="llist__heading">
          {heading}
        </h3>
      </div>

      <ul className="llist__grid">
        {links.map((item) => (
          <li key={item.title} className="llist__item">
            <a className="llist__link" href={item.url}>
              {item.title}
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default LinkList;
